export default "__VITE_ASSET__751c6357__"